import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Bidder User Services
 * !== 공매자 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/bidrusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/bidr-usr-mgmt`,
    co_api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co`,
    nodes: [],
};

export const URLS = {
    ptli0911001q: `${BASE.path}/ptli0911001q`, // Request for company approval List !==  공매자 관리 목록 ==!
    ptli0911002s: `${BASE.path}/ptli0911002s`, // Request for company approval Save !==  공매자 관리 저장 ==!
    ptli0911003s: `${BASE.path}/ptli0911003s`, // Request for company approval Details !==  공매자 관리 상세 ==!
    ptli0911004q: `${BASE.path}/ptli0911004q`, // Request for company approval Details !==  공매자 관리 상세 ==!
};

export const APIS = {
    // Check Bidder User List !==  공매자 관리 목록 조회 ==!
    getBidrUsrList: (data: any, page: number, size: number) => {
        const params = { ...data };

        if (params.usrStatCd === 'D') {
            params.usrStatCdStr = 'D';
            delete params.usrStatCd;
        } else if (params.usrStatCd != null && params.usrStatCd !== '') {
            params.usrStatCd = Number(params.usrStatCd);
        }

        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(params),
        });
    },
    // Bidder User Information !== 공매자 관리 상세 정보 조회 ==!
    getBidrUsrInfo: (xtrnUsrUuid: any) => {
        return api.get(`${BASE.api}/${xtrnUsrUuid}`);
    },

    // Create Bidder User information !==  공매 사용자 정보 등록 ==!
    createBidrUsrInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // update Bidder User information !==  기관 정보 수정 ==!
    updateBidrUsrInfo: (data: any) => {
        return api.put(`${BASE.api}`, { ...data });
    },

    //delete Bidder User information !== 공매 사용자 정보 삭제 ==!
    deleteBidrUsrInfo: (xtrnUsrUuid: any) => {
        return api.delete(`${BASE.api}/${xtrnUsrUuid}`);
    },

    // Reset the Bidder User password. !== 공매사용자 비밀번호를 초기화한다. ==!
    updateBidrUsrPwdInit: (data: any) => {
        return api.put(`${BASE.api}/pwd-init`, {
            ...data,
        });
    },

    getTinInfo: (xtrnUsrUuid: any) => {
        return api.get(`${BASE.api}/check-tin/${xtrnUsrUuid}`);
    },

    // TIN Number Search !== TIN 번호 조회 ==!
    getPayerTinNoLst: (tinNo: any, bizYn: any) =>
        comnUtils.getCode({ area: "payerTinNo", keyword: tinNo, param2: bizYn }),

    // Bidder User duplicate check !== 공매사용자 중복 체크 ==!
    getBidrDuplCheck: (xtrnUsrIdntfNo: any) => {
        return api.get(`${BASE.co_api}/getBidrDuplCheck`, {
            params: comnUtils.toGetParams({ xtrnUsrIdntfNo: xtrnUsrIdntfNo }),
        });
    },
    // Restore bidder user when deleted
    restoreBidrUsr: (xtrnUsrUuid: any) => {
        return api.put(`${BASE.api}/${xtrnUsrUuid}/restr`);
    },
    getBidrUsrExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),
};

const ynCode = [
    { label: "All", value: "A" },
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

export const SF_BIDR_USR_SRCH: TFormSchema = {
    id: "form_bidrUsrSrch",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_BIDR_TIN" },
        usrNm: { type: "text", label: "L_NM" },
        bsopPrcssStat: {
            type: "select",
            label: "L_BSOP_PRCSS_STAT",
            options: [
                { label: "Unprocessed", value: "U" },
                { label: "Approved", value: "A" },
                { label: "Returned", value: "R" },
            ],
            all: true,
        },
        usrTp: { type: "select", label: "L_USR_TP", area: "comnCd", comnCd: "COM0052", excludes: ["B", "O"] },
        actnCtgrCd: { type: "select", label: "L_ACTN_CTGR_CD", area: "comnCd", comnCd: "COM0021", required: true },
        ynCode: { type: "select", label: "Use Y/N", options: ynCode },
        usrStatCd: { type: "select", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001", required: false },
    },
};

export const SG_BIDR_USR_LIST: TGridSchema = {
    id: "grid_bidrUsrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_TP", binding: "usrTp", width: "15%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_BIDR_TIN", binding: "xtrnUsrIdntfNo", width: "15%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_ACTN_CTGR_CD", binding: "actnCtgrCdNm", width: 0 }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "usrTp" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        {
            cells: [{ binding: "actnCtgrCdNm" }],
        },
    ],
};

export const SF_BIDR_USR_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        xtrnUsrIdntfNo: { type: "text", label: "L_TIN_NO", required: true, maxLength: 9 },
        usrNm: { type: "text", label: "L_NM", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            controlSize: 10,
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10, required: true },
        usrPwd: { type: "password", label: "L_USR_PWD", required: true },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        actnCtgrCd: { type: "select", label: "L_ACTN_CTGR_CD", area: "comnCd", comnCd: "COM0021", required: true },
        usrStatCd: { type: "select", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001", required: true },
        usrTp: {
            type: "radio",
            label: "L_USR_TP",
            area: "comnCd",
            comnCd: "COM0052",
            required: true,
            excludes: ["B", "O"],
            defaultValue: "E",
        },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
    },
};

export const SG_BIDR_USR_CTGR_LIST: TGridSchema = {
    id: "grid_bidrUsrAuthList",
    options: { edit: true, checkbox: true, radio: false, index: false },
    head: [
        { cells: [{ header: "L_ACTN_CTGR_CD", binding: "actnCtgrCd", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "actnCtgrCd", align: "center", type: "select", area: "comnCd", comnCd: "COM0021" }] },
        {
            cells: [
                {
                    binding: "useYn",
                    align: "left",
                    type: "select",
                    options: [
                        { label: "Y", value: "Y" },
                        { label: "N", value: "N" },
                    ],
                },
            ],
        },
    ],
};

export const SG_BIDR_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_bidrUsrExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_TP", binding: "usrTp", width: "15%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_BIDR_TIN", binding: "xtrnUsrIdntfNo", width: "15%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_ACTN_CTGR_CD", binding: "actnCtgrCdNm", width: 0 }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "usrTp" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "xtrnUsrIdntfNo" }],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        {
            cells: [{ binding: "actnCtgrCdNm" }],
        },
    ],
};
